var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css()},[_c('AtomIcon',{key:_vm.nameIcon,class:_vm.css('icon'),attrs:{"size":11,"name":_vm.nameIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }